module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"text-01":"The page you were looking for doesn\u0027t exist","title-btn":"Back to homepage"},"fr":{"text-01":"La page que vous recherchez n\u0027existe pas","title-btn":"Retour à l\u0027accueil"}}')
  delete Component.options._Ctor
}
